import { Injectable, Inject } from '@angular/core';
import { StorageAccessor } from './StorageAccessor';
import { MemoryStorageAccessor } from './MemoryStorageAccessor';

@Injectable()
export class SessionStorageService {
	private _storage: StorageAccessor;

	constructor(@Inject('window') window: any) {
		if (window.sessionStorage) {
			this._storage = new SessionStorageAccessor();
		} else {
			this._storage = new MemoryStorageAccessor();
		}
	}

	setData(name: string, value: any): void {
		this._storage.setItem(name, value);
	}

	getData(name: string): any {
		return this._storage.getItem(name);
	}

	retrieveAndRemoveData(keyName: string): any {
		const dataToReturn = this._storage.getItem(keyName);
		this._storage.clearItem(keyName);
		return dataToReturn;
	}

	clearData(keyName: string): any {
		if (keyName) {
			this._storage.clearItem(keyName);
		}
	}
}

export class SessionStorageAccessor implements StorageAccessor {

	getItem(name: string): any {
		try {
			const storedValue = window.sessionStorage.getItem(name);
			return storedValue ? JSON.parse(storedValue) : undefined;
		} catch {
			return undefined;
		}
	}

	setItem(name: string, value: any): void {
		if (value) {
			const valueToStore = JSON.stringify(value);
			window.sessionStorage.setItem(name, valueToStore);
		} else {
			this.clearItem(name);
		}
	}

	clearItem(name: string): void {
		window.sessionStorage.removeItem(name);
	}
}
